import { gql } from '@apollo/client';

export const PUBLISH_NEW_ACTIVITIES_VERSION = gql`
  mutation PublishNewActivitiesVersion(
    $input: PublishNewActivitiesVersionInput!
  ) {
    publishNewActivitiesVersion(input: $input) {
      ... on AssessmentActivities {
        id
        status
        version
        language
        hasUnpublishedChanges
      }
      ... on LessonActivities {
        id
        status
        version
        language
        hasUnpublishedChanges
      }
    }
  }
`;

export const UPDATE_EXISTING_ACTIVITIES_VERSION = gql`
  mutation UpdateExistingActivitiesVersion(
    $input: UpdateExistingActivitiesVersionInput!
  ) {
    updateExistingActivitiesVersion(input: $input) {
      ... on AssessmentActivities {
        id
        status
        version
        language
        hasUnpublishedChanges
      }
      ... on LessonActivities {
        id
        status
        version
        language
        hasUnpublishedChanges
      }
    }
  }
`;

export const CREATE_PUBLISH_TASK = gql`
  mutation CreatePublishTask($input: CreatePublishTaskInput!) {
    createPublishTask(input: $input) {
      id
      uploadUrls {
        key
        url
        language
      }
      downloadUrl
      version
    }
  }
`;

export const GET_PUBLISH_TASK_BY_ID = gql`
  query GetPublishTaskById($id: Int!) {
    getPublishTaskById(id: $id) {
      id
      downloadUrl
      status
      assetKeys {
        print {
          key
          language
          publicToken
        }
        studentPrintables {
          key
          language
          publicToken
        }
      }
      assetDownloadUrls {
        language
        url
      }
    }
  }
`;

export const GET_ACTIVITIES_CHANGES = gql`
  query GetActivitiesChanges($input: GetActivitiesChangesInput!) {
    getActivitiesChanges(input: $input) {
      componentId
      componentType
      change
      sectionNumber
      sectionId
      numberOfAnswers
    }
  }
`;
